module.exports = __webpack_public_path__ + "img/img_prduct_content3.744f77db.svg";